export class Size {
  width: number;
  height: number;
}

export class FeatureGuidePositionData {
  position: FeatureGuidePosition;
  hostSize: Size;
  tooltipSize: Size;
}

export enum FeatureGuidePosition {
  LEFT_TOP,
  RIGHT_TOP,
  BOTTOM_LEFT,
  BOTTOM_RIGHT,
  TOP_LEFT
}
